<template>
  <div
  >
    <label
      v-if="includeOperator" 
      class="v-label v-label--active theme--light fs-10 pointer"
      @click="toggleOperator()"
    >{{field.label}} <span class="text-decoration-underline ycmd-dark-blue--text">{{operator === '$nin' ? 'MUST NOT' : 'MUST'}}</span> be{{field.field_type === 'input' ? '':' in'}}:</label>

    <v-select v-if="field.field_type === 'single_select'"
      light
      flat
      outlined
      dense
      v-model="fieldValue"
      :items="field.options"
      item-text="value"
      item-value="id"
      :label="getLabel(field)"
      :hint="field.description"
      :persistent-hint="true"
      :multiple="true"
      :disabled="disabled"
    />
    <v-text-field v-else-if="field.field_type === 'input'"
      light
      flat
      outlined
      dense
      v-model="fieldValue"
      :label="getLabel(field)"
      :hint="field.description"
      :persistent-hint="true"
      :disabled="disabled"
    />

  </div>    
</template>

<script>

export default {

  props: {
    value: {
      default: null
    },
    field: {
      default: () => {},
      type: Object
    },
    label: {
      default: '',
      type: String
    },
    initialChange: {
      default: false,
      type: Boolean
    },    
    includeOperator: {
      default: false,
      type: Boolean
    },
    operator: {
      default: '$in',
      type: String
    },
    disabled: {
        type: Boolean,
        default: false
    },  
  },
  data: () => ({
    localValues: {},
  }),
  methods: {
    getLabel(field) {
      if (this.includeOperator) {
        return null
      }
      return field.label
    },
    toggleOperator () {
      if (this.disabled) {
        return 
      }
      let value = this.fieldOperator

      this.fieldOperator = value === '$nin' ? '$in' : '$nin'

    },
  },
  computed: {
    fieldValue: {
      get: function() {
        return this.value
      },
      set: function(newValue) {
        this.$emit('input', newValue)
      }
    },
    fieldOperator: {
      get: function() {
        return this.operator
      },
      set: function(newValue) {
        this.$emit('update:operator', newValue)
      }
    }    
  },
  watch: {
  },
  mounted () {
    let nv = this.fieldValue
    if (this.initialChange) {
      this.$emit('input', nv)
    }
  }
}
</script>
<style>

div.ycmdcbl div.v-input--selection-controls__ripple{
    margin: 0px;
}
div.ycmdcbl div.v-input--selection-controls__input{
    max-height: 24px;
}
div.ycmdcbl div.v-list-item{
    min-height: 12px;
}



</style>
